import clsx from "clsx";

const AtidimSvgComponent = ({
  description: descriptions,
  svgColor,
  textColor,
}) => {
  return (
    <div
      className="flex w-full h-full  flex-row justify-center rounded-md "
      key={descriptions}
    >
      {descriptions.map((description, index) => (
        <div className="flex w-full h-full flex-row justify-center rounded-md ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 "
            viewBox="0 0 20 20"
            fill={svgColor[index]}
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <p className={clsx(`text-sm ${textColor} px-1`)}>{description}</p>
        </div>
      ))}
    </div>
  );
};
export default AtidimSvgComponent;
